import {
    actions_Group as GroupStrings_actions_Group,
    addIns_GroupButton as GroupStrings_addIns_GroupButton,
    basicText_Group as GroupStrings_basicText_Group,
    clipboard_Group as GroupStrings_clipboard_Group,
    delete_GroupButton as GroupStrings_delete_GroupButton,
    download_GroupButton as GroupStrings_download_GroupButton,
    draftWithCopilot_Group as GroupStrings_draftWithCopilot_Group,
    draw_Insert_Group as GroupStrings_draw_Insert_Group,
    draw_Selection_Group as GroupStrings_draw_Selection_Group,
    draw_Tools_Group as GroupStrings_draw_Tools_Group,
    draw_Touch_Group as GroupStrings_draw_Touch_Group,
    draw_Undo_Group as GroupStrings_draw_Undo_Group,
    encrypt_Group as GroupStrings_encrypt_Group,
    findTime_GroupButton as GroupStrings_findTime_GroupButton,
    find_GroupButton as GroupStrings_find_GroupButton,
    format_Group as GroupStrings_format_Group,
    immersiveReader_GroupButton as GroupStrings_immersiveReader_GroupButton,
    include_Group as GroupStrings_include_Group,
    insert_Group as GroupStrings_insert_Group,
    loop_Group as GroupStrings_loop_Group,
    moveAndDelete_GroupButton as GroupStrings_moveAndDelete_GroupButton,
    move_GroupButton as GroupStrings_move_GroupButton,
    new_GroupButton as GroupStrings_new_GroupButton,
    notes_GroupEdit as GroupStrings_notes_GroupEdit,
    notes_GroupNew as GroupStrings_notes_GroupNew,
    notes_GroupView as GroupStrings_notes_GroupView,
    options_Group as GroupStrings_options_Group,
    paragraph_Group as GroupStrings_paragraph_Group,
    print_GroupButton as GroupStrings_print_GroupButton,
    proofing_Group as GroupStrings_proofing_Group,
    quickSteps_Group as GroupStrings_quickSteps_Group,
    respond_GroupButton as GroupStrings_respond_GroupButton,
    save_Group as GroupStrings_save_Group,
    send_GroupButton as GroupStrings_send_GroupButton,
    sensitivity_Group as GroupStrings_sensitivity_Group,
    showField_Group as GroupStrings_showField_Group,
    styling_Group as GroupStrings_styling_Group,
    sync_GroupButton as GroupStrings_sync_GroupButton,
    table_GroupAlignment as GroupStrings_table_GroupAlignment,
    table_GroupMerge as GroupStrings_table_GroupMerge,
    table_GroupTableStyles as GroupStrings_table_GroupTableStyles,
    tags_Group as GroupStrings_tags_Group,
    tags_GroupButton as GroupStrings_tags_GroupButton,
    themes_Group as GroupStrings_themes_Group,
    tracking_Group as GroupStrings_tracking_Group,
    undo_GroupButton as GroupStrings_undo_GroupButton,
    viewLayout_Group as GroupStrings_viewLayout_Group,
    viewMessages_Group as GroupStrings_viewMessages_Group,
    viewSettings_Group as GroupStrings_viewSettings_Group,
    voice_Group as GroupStrings_voice_Group,
    window_GroupButton as GroupStrings_window_GroupButton,
    zoom_Group as GroupStrings_zoom_Group,
    mailMerge_Group as GroupStrings_mailMerge_Group,
    mailMerge_Data_Group as GroupStrings_mailMerge_Data_Group,
} from 'owa-locstrings/lib/strings/ribbon_mail_groups.locstring.json';
import {
    names_Group as MailGroupStrings_names_Group,
    pictureFormatting_Group as MailGroupStrings_pictureFormatting_Group,
    pictureMisc_Group as MailGroupStrings_pictureMisc_Group,
    pictureSize_Group as MailGroupStrings_pictureSize_Group,
    pictureText_Group as MailGroupStrings_pictureText_Group,
    report_GroupButton as MailGroupStrings_report_GroupButton,
    table_GroupAccessibility as MailGroupStrings_table_GroupAccessibility,
    table_GroupBorders as MailGroupStrings_table_GroupBorders,
    table_GroupInsert as MailGroupStrings_table_GroupInsert,
    table_GroupStructure as MailGroupStrings_table_GroupStructure,
    teamsChat_Group as MailGroupStrings_teamsChat_Group,
    spamAddins_GroupButton as MailGroupStrings_spamAddins_GroupButton,
    sendReceive_Group as MailGroupStrings_sendReceive_Group,
    preferences_Group as MailGroupStrings_preferences_Group,
    viewArrangement_Group as MailGroupStrings_viewArrangement_Group,
    currentView_Group as MailGroupStrings_currentView_Group,
    groups_GroupButton as MailGroupStrings_groups_GroupButton,
    apps_GroupButton as MailGroupStrings_apps_GroupButton,
    addIn_GroupButton as MailGroupStrings_addIn_GroupButton,
    protection_GroupButton as MailGroupStrings_protection_GroupButton,
} from './ribbon_mail_groups.locstring.json';
import {
    favoriteSettingsButton as RibbonMailStrings_favoriteSettingsButton,
    folder_tab as TabStrings_folder_tab,
} from './ribbon_mail_strings.locstring.json';
import {
    help_Group_Groups as HelpGroupStrings_help_Group_Groups,
    tools_Group_Groups as HelpGroupStrings_tools_Group_Groups,
} from 'owa-locstrings/lib/strings/ribbon_groups.locstring.json';
import type { RibbonGroupId } from 'owa-ribbon-ids';
import { type MailRibbonGroupId } from 'owa-ribbon-ids/lib/mailRibbonId';
import { type HelpRibbonGroupId } from 'owa-ribbon-ids/lib/helpControlId';
import type { ResourceId } from 'owa-localize';
import {
    searchRefine_Group,
    searchTools_Group,
    searchRefiners_Group,
    searchEntities_Group,
} from './ribbon_mail_search_tab.locstring.json';

/**
 * Maps each group to its corresponding string for the corresponding group
 */
export const defaultGroupStringMap: Map<RibbonGroupId, ResourceId> = new Map<
    RibbonGroupId,
    ResourceId
>()
    .set(101, GroupStrings_addIns_GroupButton)
    .set(192, MailGroupStrings_spamAddins_GroupButton)
    .set(102, GroupStrings_clipboard_Group)
    .set(104, GroupStrings_delete_GroupButton)
    .set(197, MailGroupStrings_report_GroupButton)
    .set(105, GroupStrings_download_GroupButton)
    .set(106, GroupStrings_encrypt_Group)
    .set(214, RibbonMailStrings_favoriteSettingsButton)
    .set(208, TabStrings_folder_tab)
    .set(108, GroupStrings_find_GroupButton)
    .set(109, MailGroupStrings_groups_GroupButton)
    .set(211, MailGroupStrings_apps_GroupButton)
    .set(212, MailGroupStrings_addIn_GroupButton)
    .set(213, MailGroupStrings_protection_GroupButton)
    .set(134, GroupStrings_basicText_Group)
    .set(135, GroupStrings_paragraph_Group)
    .set(110, GroupStrings_immersiveReader_GroupButton)
    .set(111, GroupStrings_include_Group)
    .set(113, GroupStrings_move_GroupButton)
    .set(114, GroupStrings_moveAndDelete_GroupButton)
    .set(115, MailGroupStrings_names_Group)
    .set(116, GroupStrings_new_GroupButton)
    .set(144, GroupStrings_notes_GroupNew)
    .set(145, GroupStrings_notes_GroupEdit)
    .set(146, GroupStrings_notes_GroupView)
    .set(117, MailGroupStrings_preferences_Group)
    .set(118, GroupStrings_print_GroupButton)
    .set(121, GroupStrings_respond_GroupButton)
    .set(122, '') //Ribbon customizer never has displayed name
    .set(194, GroupStrings_window_GroupButton)
    .set(123, GroupStrings_save_Group)
    .set(124, GroupStrings_send_GroupButton)
    .set(125, GroupStrings_sensitivity_Group)
    .set(127, GroupStrings_sync_GroupButton)
    .set(209, MailGroupStrings_sendReceive_Group)
    .set(128, GroupStrings_tags_GroupButton)
    .set(132, '') // Toolbar groups never have displayed named
    .set(133, '') // Toolbar groups never have displayed named
    .set(130, GroupStrings_undo_GroupButton)
    .set(210, MailGroupStrings_viewArrangement_Group)
    .set(154, GroupStrings_viewLayout_Group)
    .set(153, GroupStrings_viewMessages_Group)
    .set(152, GroupStrings_viewSettings_Group)
    .set(147, MailGroupStrings_table_GroupStructure)
    .set(148, GroupStrings_table_GroupTableStyles)
    .set(149, GroupStrings_table_GroupMerge)
    .set(150, MailGroupStrings_table_GroupInsert)
    .set(151, GroupStrings_table_GroupAlignment)
    .set(196, MailGroupStrings_table_GroupBorders)
    .set(201, MailGroupStrings_table_GroupAccessibility)
    .set(167, GroupStrings_tags_Group)
    .set(168, GroupStrings_actions_Group)
    .set(165, GroupStrings_addIns_GroupButton)
    .set(166, GroupStrings_findTime_GroupButton)
    .set(161, GroupStrings_insert_Group)
    .set(162, GroupStrings_options_Group)
    .set(159, GroupStrings_addIns_GroupButton)
    .set(160, GroupStrings_tags_GroupButton)
    .set(158, GroupStrings_include_Group)
    .set(157, GroupStrings_basicText_Group)
    .set(163, GroupStrings_clipboard_Group)
    .set(169, GroupStrings_loop_Group)
    .set(180, GroupStrings_draftWithCopilot_Group)
    .set(170, GroupStrings_save_Group)
    .set(171, GroupStrings_findTime_GroupButton)
    .set(172, GroupStrings_proofing_Group)
    .set(173, GroupStrings_loop_Group)
    .set(174, GroupStrings_format_Group)
    .set(175, GroupStrings_showField_Group)
    .set(176, GroupStrings_tracking_Group)
    .set(120, GroupStrings_quickSteps_Group)
    .set(177, GroupStrings_themes_Group)
    .set(179, GroupStrings_styling_Group)
    .set(187, GroupStrings_voice_Group)
    .set(11001, HelpGroupStrings_help_Group_Groups)
    .set(11002, HelpGroupStrings_tools_Group_Groups)
    .set(181, GroupStrings_draw_Undo_Group)
    .set(182, GroupStrings_draw_Selection_Group)
    .set(183, GroupStrings_draw_Tools_Group)
    .set(184, GroupStrings_draw_Touch_Group)
    .set(185, GroupStrings_draw_Insert_Group)
    .set(188, MailGroupStrings_pictureFormatting_Group)
    .set(189, MailGroupStrings_pictureText_Group)
    .set(190, MailGroupStrings_pictureSize_Group)
    .set(191, MailGroupStrings_pictureMisc_Group)
    .set(193, GroupStrings_zoom_Group)
    .set(195, GroupStrings_tracking_Group)
    .set(198, MailGroupStrings_teamsChat_Group)
    .set(199, GroupStrings_print_GroupButton)
    .set(202, searchRefine_Group)
    .set(203, searchTools_Group)
    .set(204, searchRefiners_Group)
    .set(205, searchEntities_Group)
    .set(206, GroupStrings_mailMerge_Group)
    .set(207, GroupStrings_mailMerge_Data_Group);

const win32GroupStringOverrides: ReadonlyMap<RibbonGroupId, ResourceId> = new Map([
    [152, MailGroupStrings_currentView_Group],
]);

export function getDefaultGroupString(
    groupId: RibbonGroupId,
    useWin32GroupStrings: boolean
): ResourceId | undefined {
    return (
        (useWin32GroupStrings ? win32GroupStringOverrides.get(groupId) : undefined) ??
        defaultGroupStringMap.get(groupId)
    );
}
